import React from 'react';
import { MeasureDate } from './MeasureDate';
import { CodeMeasureCombobox, ParamMeasureCombobox } from './MeasureCombobox';
import { MeasureTextInputField } from './MeasureTextInputField';
import { INPUT_VALUE_TYPE } from './utils';
import './input-by-type.css';

/**
 * @param {object} props
 * @prop {REGEX | LIST | DATE} valueType
 * @prop {object} confines - for REGEX valueType
 * @prop {number | string} confines.minWarningValue предупреждение
 * @prop {number | string} confines.maxWarningValue предупреждение
 * @prop {number | string} confines.minValue строго
 * @prop {number | string} confines.maxValue строго
 * @prop {string} [formatValue] формат вводимого значения:
 * * %d -ввод любого числа
 * * %s или undefined - ввод любых символы
 * * string - format для даты
 * @prop {number | undefined} codeId нужен для выбора значения из словаря кодов (voc.codes)
 * @prop {number | undefined} paramId нужен для выбора значения из словаря параметров (voc.descriptors)
 * @prop ...textInputFieldProps
 */
export const DataValueInputByType = React.memo((props) => {
  switch (props.valueType) {
    case INPUT_VALUE_TYPE.list:
      if (props.codeId) return <CodeMeasureCombobox {...props} />;
      if (props.paramId) return <ParamMeasureCombobox {...props} />;
      return <MeasureTextInputField {...props} />;
    case INPUT_VALUE_TYPE.date:
      return <MeasureDate {...props} />;
    default: return <MeasureTextInputField {...props} />;
  }
});
DataValueInputByType.displayName = 'DataValueInputByType';
